console.log('js/messages.js -> v0.1.0');
$(function () {
	var MEGABYTE = 1024 * 1024;

	var messageForm = {
		errorMessages: [],

		validate: function(arr, $form) {
			messageForm.errorMessages = [];
			var $files = messageForm.usedInputs();

			/* this one only allows availability to set if there's a message */
			if (messageForm.emptyMessage() && !$('#available-button').length)
				messageForm.errorMessages.push(translation.the_message_cant_be_empty);
			if (messageForm.hasExcessFiles($files)) {
				messageForm.errorMessages.push("File size must be less then 10MB.");
			} else if (messageForm.allFileSize($files) > 49 * MEGABYTE) {
				messageForm.errorMessages.push("The total size of attachments too large. Try to download them individually.")
			} if( $('.js-submit-org-dialog-form').hasClass('disabled') ){
				messageForm.errorMessages.push("You just clicked 'send message'. Wait a few seconds before sending another.")
			}
			// TODO add error message if form has already been submitted

			return messageForm.showErrorMessages($form);
		},

		showErrorMessages: function($form) {
			if(this.errorMessages.length) {
				$(".js-dialog-alert.dialog-alert__item--success").remove()
				$(".js-dialog-alert").removeClass('hide').addClass('dialog-alert__item--danger')
				$(".js-alert-text").html(this.errorMessages.join(' '))

				// scroll to error message
				var pos = $('#message-form-wrapper').offset().top;
				$('body, html').animate({scrollTop: pos});

				if ($form)
					setTimeout(function() { $.rails.enableFormElements($form) }, 13*2);

				return false;
			} else {
				// TODO mark form as submitted
				var $submitButton = $('.js-submit-org-dialog-form');
				var textDisabled = $('.js-submit-org-dialog-form').data("disable-with");
				$submitButton.addClass('disabled');
				$submitButton.attr('disabled', 1);
				$submitButton.val(textDisabled);

				return true;
			}
		},

		hasExcessFiles: function($files) {
			return $files.filter(
				function () {
					return this.files[0].size > 10*MEGABYTE
				}
			).length
		},

		allFileSize: function($files) {
			var sum = 0;
			$files.each(
				function () {
					sum += $(this)[0].files[0].size
				}
			)
			return sum;
		},

		readablizeBytes: function(bytes) {
			var s = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
			var e = Math.floor(Math.log(bytes) / Math.log(1024));
			return (bytes / Math.pow(1024, e)).toFixed(1) + " " + s[e];
		},

		emptyInputs: function(className) {
			var empty = [];
			$(`#message-form-wrapper input:file:not(#new_attachment)`).each(function() {
				if (!this.files || (this.files.length == 0))
					empty.push(this);
			});
			return $(empty);
		},

		emptyMessage: function() {
			return $("#simple_message_form_message").val() == "";
		},

		usedInputs: function() {
			var used = [];
			$("#message-form-wrapper input:file:not(#new_attachment)").each(function() {
				if (this.files && (this.files.length > 0))
					used.push(this);
			});
			return $(used);
		}
	}

	$('#noajax_dialogs_form').on('submit', function() {
		return messageForm.validate();
	});

	$("#message-form-wrapper").on('refresh', '#new_simple_message_form, #noajax_dialogs_form',
		function () {
			$("#new_simple_message_form").ajaxForm({
				dataType: "script",
				beforeSubmit: messageForm.validate
			});

			$("#simple_message_form_message").autosize().css('resize', 'vertical');
		}
	);

	$("#message-form-wrapper").on('click', "label[for='undefined']",
		function (event) {
			event.preventDefault();
			alert('You can load only 5 files in this browser.');
		}
	)

	$("#message-form-wrapper").on('change', "input:file",
		function (event) {
			const $target = $(event.target)

			const $attachments = $target.closest('.attachments')
			const $actionWrapper = $target.closest('.action-wrapper')

			const inputs = []
			$actionWrapper.find('input:file:not(#new_attachment)').each(function() {
				if (!this.files || this.files.length == 0) {
					inputs.push(this);
				}
			});
			const $inputs = $(inputs);

			const siblingInputs = $target.siblings('input:file:not(#new_attachment)')
			const emptyInputs = siblingInputs.filter(function () {
				const value = this.value
				return !value
			})

			var newFileId = 'undefined';
			if(!emptyInputs.length) {
				if(document.addEventListener) { // ie 9+
					var $pattern = $("#new_attachment");

					var $fileInput = $pattern.clone();
					$fileInput.prop('disabled', false);
					newFileId = 'file_' + siblingInputs.length;
					$fileInput.attr('id', newFileId);
					$fileInput.insertAfter(
						$("#message-form-wrapper input:file:not(#new_attachment):last")
					);
				}
			} else {
				newFileId = emptyInputs.first().attr('id');
			}

			$('label.file').attr('for', newFileId);

			$attachments.trigger('addFile')
		}
	);

	$("body").on('addFile', '.attachments',
		function () {
			var $attachmentsWrapper = $(this);

			const actionWrapper = $attachmentsWrapper.closest('.action-wrapper')

			var $list = $attachmentsWrapper.find('.list')
			$list.html('');
			$attachmentsWrapper.find("input:file:not(#new_attachment)").each(function () {
				if (this.files && this.files.length > 0) {
					var file = this.files[0];
					const element = "<li><span class='file-name'>" + file.name + " (" + messageForm.readablizeBytes(file.size) + ")</span>&nbsp;<span class='close delete'>&times;</span></li>"
					$list.append(element);
				}
			});
		}
	);

	$("#message-form-wrapper").on('click', '.delete',
		function () {
			var $listItem = $(this).parent();
			$("#message-form-wrapper input.file:not(#new_attachment):eq(" + $listItem.index() + ")").val('');
			$('label.file').attr('for', messageForm.emptyInputs().first().attr('id'));
			$listItem.remove();
		}
	);

	$('.new_simple_message_form').trigger('refresh');

	$("#simple_message_form_message").keyup(function() {
		saveData();
	});

	loadData();

	$('#available-button, #notavailable-button, #not-suitable-button').click(function(){
		offLoadData();
	});

	$("#save_edit_package").click(function(event){
		var $form = $("form#edit_package");

		$(this).prop('disabled', true);
		$(this).html("<i class='ebs-icon-spinner spin-icon'></i> " + $(this).data("progress-text"));
		$form.submit();

		event.stopImmediatePropagation();

		return false;
	});

	function loadData(){
		if(sessionStorage && !!sessionStorage.getItem("tripaneer-listing-inquiry-message") && !(/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream))	{
			var elem = sessionStorage.getItem("tripaneer-listing-inquiry-message");
			$("#simple_message_form_message").val(elem);
		}
	}

	function offLoadData(){
		sessionStorage.setItem("tripaneer-listing-inquiry-message", "");
	}

	function saveData(event){
		if($("#simple_message_form_message").length && !!$("#simple_message_form_message").val())
			sessionStorage.setItem("tripaneer-listing-inquiry-message", $("#simple_message_form_message").val());

		return false;
	}
})
